/** 商品一覧と商品選択で共通に使う検索入力・ページ送り。検索の確定は親の form が行う。 */
import { Button } from "visumo-data-agent-web-shared";

export function ProductSearchField({
  value,
  onChange,
}: {
  readonly value: string;
  readonly onChange: (value: string) => void;
}) {
  return (
    <label className="vd-field" style={{ flex: "1 1 240px" }}>
      <span className="vd-field-hint">商品名・SKU・ブランド</span>
      <input
        className="vd-input"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder="キーワード"
      />
    </label>
  );
}

export function ProductLoadMore({
  hasNextPage,
  fetching,
  onLoad,
  label = "もっと読む",
}: {
  readonly hasNextPage: boolean;
  readonly fetching: boolean;
  readonly onLoad: () => void;
  readonly label?: string;
}) {
  return hasNextPage ? (
    <div className="vd-row" style={{ marginTop: 12 }}>
      <Button disabled={fetching} onClick={onLoad}>
        {fetching ? "読み込んでいます" : label}
      </Button>
    </div>
  ) : null;
}
